export const defaultTimeoutAPI = window.urls
  ? window.urls.defaultTimeoutAPI
    ? window.urls.defaultTimeoutAPI
    : 10000
  : 10000;
